import { FeatureFlag } from '../FeatureFlag';

export const enableColumnOptionsGlobalDefaultsPanel = new FeatureFlag({
    key: 'enable-column-options-global-defaults-panel',
    defaultValue: false,
});
